import { render, staticRenderFns } from "./GSnackbar.vue?vue&type=template&id=4fdf945c&scoped=true"
import script from "./GSnackbar.vue?vue&type=script&lang=js"
export * from "./GSnackbar.vue?vue&type=script&lang=js"
import style0 from "./GSnackbar.vue?vue&type=style&index=0&id=4fdf945c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdf945c",
  null
  
)

export default component.exports